import React, { useEffect, useState } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
export function Datenschutz() {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  useEffect(() => {
    // Try to fetch content directly from API
    fetch('https://app.dieter-datenschutz.de/api/livedoc/cmkjjny160zwwn00t6xz6jhm1').then(response => {
      if (!response.ok) throw new Error('Failed to load');
      return response.text();
    }).then(html => {
      setContent(html);
      setLoading(false);
    }).catch(err => {
      console.error('Failed to load Dieter content:', err);
      setError(true);
      setLoading(false);
    });
  }, []);
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 flex flex-col" data-id="element-174">
      <Header forceSolid={true} data-id="element-175" />
      <main className="flex-grow pt-32 pb-24 px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="max-w-4xl mx-auto bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-slate-200" data-id="element-177">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-8" data-id="element-178">
            Datenschutzerklärung
          </h1>

          {loading && <div className="text-center py-12" data-id="element-179">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" data-id="element-180"></div>
              <p className="mt-4 text-slate-600" data-id="element-181">
                Datenschutzerklärung wird geladen...
              </p>
            </div>}

          {error && <div className="bg-blue-50 border border-blue-200 rounded-lg p-6" data-id="element-182">
              <p className="text-slate-700 mb-4" data-id="element-183">
                Die Datenschutzerklärung kann in dieser Ansicht nicht direkt
                geladen werden.
              </p>
              <a href="https://app.dieter-datenschutz.de/api/livedoc/cmkjjny160zwwn00t6xz6jhm1" target="_blank" rel="nofollow noopener" className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors" data-id="element-184">
                Datenschutzerklärung in neuem Tab öffnen →
              </a>
            </div>}

          {!loading && !error && content && <div className="prose max-w-none" dangerouslySetInnerHTML={{
          __html: content
        }} data-id="element-185" />}
        </div>
      </main>
      <Footer data-id="element-186" />
    </div>;
}